import { Controller } from 'react-hook-form'

import { Textarea } from '@/components/ui/textarea'

import { EmailTemplate } from './constants'

type TemplateEditorProps = {
  template: EmailTemplate
  control: any
  label: string
  rows: number
}

export const TemplateEditor = ({ template, control, label, rows }: TemplateEditorProps) => (
  <Controller
    key={template.key}
    name={`tenant.settings.${template.bodyField}` as any}
    control={control}
    render={({ field }) => (
      <div>
        <label className="mb-1 block text-sm font-medium text-gray-700">{label}</label>
        <Textarea
          value={field.value || template.defaultBody}
          onChange={field.onChange}
          rows={rows}
          className="w-full"
          placeholder={template.defaultBody}
        />
      </div>
    )}
  />
)
